import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Divider,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  useMediaQuery,
  Avatar,
  CardHeader,
  Tooltip,
  IconButton,
  Button,
} from "@mui/material";
import {
  useGetAllStaffDhashboardFristQuery,
  useGetPositionQuery,
  useGetMissingPunchOutQuery,
  useGetTeamQuery,
  useGetPayrollDhashboardDataQuery,
  useGetOutOfLocationQuery,
} from "../../../Api/attoDeskApi";
import {
  IPosition,
  ITeam,
  IPunchEmpRecord,
  historyPuncRecord,
} from "../../../Api/Interface/api.interface";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import GroupIcon from "@mui/icons-material/Group";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Badge from "@mui/material/Badge";
import { CiEdit } from "react-icons/ci";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import { GiReceiveMoney } from "react-icons/gi";
import { FaUserClock } from "react-icons/fa";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AttendanceTimeline from "./Component/timelinechart";
import PayrollPieChart from "./Component/payroll";
import PayrollBarChart from "./Component/payrollBarChart";
import MonthlyWorkedDaysBarChart from "./Component/MonthlyWorkedDaysBarChart";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);
const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

interface ITeampopup {
  staffId: string;
}

const Index = ({ staffId }: ITeampopup) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const getStartOfWeek = () => dayjs().startOf("week");
  const getEndOfWeek = () => dayjs().endOf("week");

  const getToday = () => dayjs().startOf("day");
  const getYesterday = () => dayjs().subtract(1, "day").startOf("day");
  const getTomorrow = () => dayjs().add(1, "day").startOf("day");

  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(1000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedCilent, setSelectedClient] = useState<string | "">("");
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs>(getToday());
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs>(getTomorrow());

  // const [selectedPayrollStartDate, setSelectedPayrollStartDate] =
  //   useState<Dayjs | null>(null);

  // const [selectedPayrollEndDate, setSelectedPayrollEndDate] =
  //   useState<Dayjs | null>(null);

  const [selectedPayrollStartDate, setSelectedPayrollStartDate] =
    useState<Dayjs>(dayjs().startOf("year"));

  const [selectedPayrollEndDate, setSelectedPayrollEndDate] = useState<Dayjs>(
    dayjs().endOf("year")
  );

  const { data, isLoading, isError, refetch } = useGetMissingPunchOutQuery();

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const { data: payrollDhashboardData, isLoading: dashboardpayrollIsLoading } =
    useGetPayrollDhashboardDataQuery({
      id: String(staffId),
      startDate: selectedPayrollStartDate?.format("YYYY-MM-DD"),
      endDate: selectedPayrollEndDate?.format("YYYY-MM-DD"),
    });

  const {
    data: outOfLocationData,
    isLoading: outOfLocationIsLoadig,
    isError: outOfLocationIsError,
    refetch: outOfLocationRefetch,
  } = useGetOutOfLocationQuery({
    date: dayjs().format("YYYY-MM-DD"),
  });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const outOfLocationRecords: historyPuncRecord[] = Array.isArray(
    outOfLocationData?.data
  )
    ? (outOfLocationData?.data as historyPuncRecord[])
    : [];

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
        positionName: string | null;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();
      const positionName = postionMap.get(teamMember.teamPositionId) || null;

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
        positionName,
      });
    });

    return map;
  }, [teamList, postionMap]);

  const coursings: IPunchEmpRecord[] = Array.isArray(data?.data)
    ? (data?.data as IPunchEmpRecord[])
    : [];

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // const handleStartDateChange = (newValue: Dayjs | null) => {
  //   if (newValue) {
  //     setSelectedStartDate(newValue);
  //   }
  // };

  // const handleEndDateChange = (newValue: Dayjs | null) => {
  //   if (newValue) {
  //     setSelectedEndDate(newValue);
  //   }
  // };

  const handleStartDateChange = (newValue: Dayjs | null) => {
    if (newValue) {
      setSelectedStartDate(newValue.startOf("day"));
    }
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    if (newValue) {
      setSelectedEndDate(newValue.endOf("day"));
    }
  };

  const handlePayrollStartDateChange = (newValue: Dayjs | null) => {
    if (newValue) {
      setSelectedPayrollStartDate(newValue.startOf("day"));
    }
  };

  const handlePayrollEndDateChange = (newValue: Dayjs | null) => {
    if (newValue) {
      setSelectedPayrollEndDate(newValue.endOf("day"));
    }
  };

  const { data: clientData, isLoading: clientIsLoading } =
    useGetAllStaffDhashboardFristQuery({
      id: String(staffId),
    });

  if (isLoading || tenantIsLoading || positionLoading || clientIsLoading) {
    return (
      <Box p={isMobile ? 2 : 1}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Skeleton
              variant="rectangular"
              height={50}
              animation="wave"
              sx={{
                borderRadius: setCardBRadius,
                backgroundColor: "#d0ddd0",
              }}
            />
          </Grid>
          <Grid item lg={3} md={12} sm={12} xs={12}>
            <Skeleton
              variant="rectangular"
              height={100}
              animation="wave"
              sx={{
                borderRadius: setCardBRadius,
                backgroundColor: "#d0ddd0",
              }}
            />
          </Grid>
          <Grid item lg={9} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              {[...Array(6)].map((_, index) => (
                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={6}
                  key={`bottom-skeleton-${index}`}
                >
                  <Skeleton
                    variant="rectangular"
                    height={50}
                    animation="wave"
                    sx={{
                      borderRadius: setCardBRadius,
                      backgroundColor: "#d0ddd0",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          {[...Array(1)].map((_, index) => (
            <Grid item xs={12} lg={12} key={`bottom-skeleton-${index}`}>
              <Skeleton
                variant="rectangular"
                height={300}
                animation="wave"
                sx={{
                  borderRadius: setCardBRadius,
                  backgroundColor: "#d0ddd0",
                }}
              />
            </Grid>
          ))}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Skeleton
              variant="rectangular"
              height={50}
              animation="wave"
              sx={{
                borderRadius: setCardBRadius,
                backgroundColor: "#d0ddd0",
              }}
            />
          </Grid>
          <Grid item lg={3} md={12} sm={12} xs={12}>
            <Skeleton
              variant="rectangular"
              height={100}
              animation="wave"
              sx={{
                borderRadius: setCardBRadius,
                backgroundColor: "#d0ddd0",
              }}
            />
          </Grid>
          <Grid item lg={9} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              {[...Array(8)].map((_, index) => (
                <Grid
                  item
                  lg={3}
                  md={6}
                  sm={6}
                  xs={6}
                  key={`bottom-skeleton-${index}`}
                >
                  <Skeleton
                    variant="rectangular"
                    height={50}
                    animation="wave"
                    sx={{
                      borderRadius: setCardBRadius,
                      backgroundColor: "#d0ddd0",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          {[...Array(1)].map((_, index) => (
            <Grid item xs={12} lg={12} key={`bottom-skeleton-${index}`}>
              <Skeleton
                variant="rectangular"
                height={300}
                animation="wave"
                sx={{
                  borderRadius: setCardBRadius,
                  backgroundColor: "#d0ddd0",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <div>
      <Card
        sx={{
          height: "100%",
          background: theme.palette.cardAdd.bgColor,
          boxShadow: "none",
          borderRadius: setCardBRadius,
          //   border: `1px solid ${theme.palette.primary.main}`,
        }}
      >
        <Grid container>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              padding: isMobile ? 1 : 2,
              minHeight: "100vh",
              borderRadius: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.staffHeadingDhashboardSmallCard}>
                  <CardContent>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      width="100%"
                      textAlign="center"
                    >
                      <Typography variant="h5" fontWeight="bold">
                        Attendance Summary
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={3} md={12} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCard2}>
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{ mb: 2, textAlign: "center" }}
                    >
                      Attendance Filter
                    </Typography>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box display="flex" flexDirection="column" gap={2}>
                        {/* Start Date */}
                        <Box>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            Start Date
                          </Typography>

                          <DatePicker
                            value={selectedStartDate}
                            onChange={handleStartDateChange}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                            sx={{ width: "100%" }}
                          />
                        </Box>

                        {/* End Date */}
                        <Box>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            End Date
                          </Typography>

                          <DatePicker
                            value={selectedEndDate}
                            onChange={handleEndDateChange}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                            sx={{ width: "100%" }}
                          />
                        </Box>
                      </Box>
                    </LocalizationProvider>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={9} md={12} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCardWithoutBorder}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={4} md={6} sm={6} xs={6}>
                          <Card className={classes.staffDhashboardSmallCard2}>
                            <CardContent>
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                width="100%"
                                textAlign="center"
                              >
                                <Typography className={classes.h5}>
                                  Today's IN
                                </Typography>

                                <Typography
                                  className={classes.h3}
                                  fontWeight={600}
                                  pt={1}
                                >
                                  {`${
                                    clientData?.data.today_in_schedule ?? "0"
                                  } | ${clientData?.data.today_in ?? "-"}`}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item lg={4} md={6} sm={6} xs={6}>
                          <Card className={classes.staffDhashboardSmallCard2}>
                            <CardContent>
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                width="100%"
                                textAlign="center"
                              >
                                <Typography className={classes.h5}>
                                  This Week's IN
                                </Typography>

                                <Typography
                                  className={classes.h3}
                                  fontWeight={600}
                                  pt={1}
                                >
                                  {`${
                                    clientData?.data.week_in_schedule ?? "0"
                                  } | ${clientData?.data.week_in ?? "-"}`}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item lg={4} md={6} sm={6} xs={6}>
                          <Card className={classes.staffDhashboardSmallCard2}>
                            <CardContent>
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                width="100%"
                                textAlign="center"
                              >
                                <Typography className={classes.h5}>
                                  This Month In
                                </Typography>

                                <Typography
                                  className={classes.h3}
                                  fontWeight={600}
                                  pt={1}
                                >
                                  {`${
                                    clientData?.data.month_in_schedule ?? "0"
                                  } | ${clientData?.data.month_in ?? "-"}`}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item lg={4} md={6} sm={6} xs={6}>
                          <Card className={classes.staffDhashboardSmallCard2}>
                            <CardContent>
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                width="100%"
                                textAlign="center"
                              >
                                <Typography className={classes.h5}>
                                  Today's
                                </Typography>

                                <Typography
                                  className={classes.h3}
                                  fontWeight={600}
                                  pt={1}
                                >
                                  {`${
                                    clientData?.data.today_in_hour_schedule ??
                                    "0"
                                  } | ${clientData?.data.today_in_hour ?? "-"}`}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item lg={4} md={6} sm={6} xs={6}>
                          <Card className={classes.staffDhashboardSmallCard2}>
                            <CardContent>
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                width="100%"
                                textAlign="center"
                              >
                                <Typography className={classes.h5}>
                                  This Week's
                                </Typography>

                                <Typography
                                  className={classes.h3}
                                  fontWeight={600}
                                  pt={1}
                                >
                                  {`${
                                    clientData?.data.week_in_hour_schedule ??
                                    "0"
                                  } | ${clientData?.data.week_in_hour ?? "-"}`}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item lg={4} md={6} sm={6} xs={6}>
                          <Card className={classes.staffDhashboardSmallCard2}>
                            <CardContent>
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                width="100%"
                                textAlign="center"
                              >
                                <Typography className={classes.h5}>
                                  This Month's
                                </Typography>

                                <Typography
                                  className={classes.h3}
                                  fontWeight={600}
                                  pt={1}
                                >
                                  {`${
                                    clientData?.data.month_in_hour_schedule ??
                                    "0"
                                  } | ${clientData?.data.month_in_hour ?? "-"}`}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCard2}>
                  <AttendanceTimeline
                    staffId={String(staffId)}
                    selectedStartDate={selectedStartDate}
                    selectedEndDate={selectedEndDate}
                  />
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCard2}>
                  <MonthlyWorkedDaysBarChart staffId={String(staffId)} />
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCardWithoutBorder}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Card
                            className={classes.staffHeadingDhashboardSmallCard}
                          >
                            <CardContent>
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                width="100%"
                                textAlign="center"
                              >
                                <Typography variant="h5" fontWeight="bold">
                                  Payroll Summary
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={3} md={12} sm={12} xs={12}>
                      <Card className={classes.staffDhashboardSmallCard2}>
                        <CardContent>
                          <Typography
                            variant="h6"
                            sx={{ mb: 2, textAlign: "center" }}
                          >
                            Payroll Filter
                          </Typography>

                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box display="flex" flexDirection="column" gap={2}>
                              <Box>
                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                  Start
                                </Typography>

                                <DatePicker
                                  views={["year", "month"]}
                                  value={selectedPayrollStartDate}
                                  onChange={handlePayrollStartDateChange}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "small",
                                    },
                                  }}
                                  sx={{ width: "100%" }}
                                />
                              </Box>

                              <Box>
                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                  End
                                </Typography>

                                <DatePicker
                                  views={["year", "month"]}
                                  value={selectedPayrollEndDate}
                                  onChange={handlePayrollEndDateChange}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "small",
                                    },
                                  }}
                                  sx={{ width: "100%" }}
                                />
                              </Box>
                            </Box>
                          </LocalizationProvider>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item lg={9} md={12} sm={12} xs={12}>
                      <Card
                        className={
                          classes.staffDhashboardSmallCardWithoutBorder
                        }
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                        Payroll
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.number_payroll_count
                                          ? `${clientData.data.number_payroll_count}`
                                          : "0"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                        Hours 
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.total_hours
                                          ? `${clientData.data.total_hours} hrs`
                                          : "0"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                      Regular
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.total_normal_hours
                                          ? `${clientData.data.total_normal_hours} hrs`
                                          : "0 hrs"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                      OT
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.total_ot_hours
                                          ? `${clientData.data.total_ot_hours} hrs`
                                          : "0"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                         Pay
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.total_salary
                                          ? `$ ${clientData.data.total_salary}`
                                          : "0"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                      Regular
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.total_gross_salary
                                          ? `$ ${clientData.data.total_gross_salary}`
                                          : "0"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                         OT 
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.total_ot_salary
                                          ? `$ ${clientData.data.total_ot_salary}`
                                          : "0"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                              <Grid item lg={3} md={6} sm={6} xs={6}>
                                <Card
                                  className={classes.staffDhashboardSmallCard2}
                                >
                                  <CardContent>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                      justifyContent="center"
                                      width="100%"
                                      textAlign="center"
                                    >
                                      <Typography className={classes.h5}>
                                       Adjustment
                                      </Typography>

                                      <Typography
                                        className={classes.h3}
                                        fontWeight={600}
                                        pt={1}
                                      >
                                        {clientData?.data.total_bonus
                                          ? `$ ${clientData.data.total_bonus}`
                                          : "0"}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    {/* <Grid item lg={9} md={12} sm={12} xs={12}>
                      <Card
                        className={
                          classes.staffDhashboardSmallCardWithoutBorder
                        }
                      >
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.cardGreenBAckGroundColor}
                          >
                            <Grid container spacing={2}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      Total Normal Hours :
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {payrollDhashboardData?.data
                                        .total_normal_hours
                                        ? `${payrollDhashboardData.data.total_normal_hours} hrs`
                                        : "0.00 hrs"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      Total OT Hours :
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                    pb={2}
                                    borderBottom={0.5}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {payrollDhashboardData?.data
                                        .total_ot_hours
                                        ? `${payrollDhashboardData.data.total_ot_hours} hrs`
                                        : "0.00 hrs"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12} py={1}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography className={classes.h4}>
                                      Total Hours :
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography className={classes.h4}>
                                      {payrollDhashboardData?.data.total_hours
                                        ? `${payrollDhashboardData.data.total_hours} hrs`
                                        : "0.00 hrs"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.cardGreenBAckGroundColor}
                          >
                            <Grid container spacing={2}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      Total Normal Working Salary :
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {payrollDhashboardData?.data
                                        .total_gross_salary
                                        ? `$ ${payrollDhashboardData.data.total_gross_salary}`
                                        : "$ 0.00"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      Total OT Salary :
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {payrollDhashboardData?.data
                                        .total_ot_salary
                                        ? `$ ${payrollDhashboardData.data.total_ot_salary}`
                                        : "$ 0.00"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      Total Adjustment Amount :
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                    pb={1}
                                    borderBottom={0.5}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {payrollDhashboardData?.data.total_bonus
                                        ? `$ ${payrollDhashboardData.data.total_bonus}`
                                        : "$ 0.00"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12} py={2}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography className={classes.h4}>
                                      Total Amount
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography className={classes.h4}>
                                      {payrollDhashboardData?.data.total_salary
                                        ? `$ ${payrollDhashboardData.data.total_salary}`
                                        : "$ 0.00"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid> */}
                   
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCard2}>
                  <PayrollPieChart
                    staffId={String(staffId)}
                    selectedStartDate={selectedPayrollStartDate}
                    selectedEndDate={selectedPayrollEndDate}
                  />
                </Card>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCard2}>
                  <PayrollBarChart
                    staffId={String(staffId)}
                    selectedStartDate={selectedPayrollStartDate}
                    selectedEndDate={selectedPayrollEndDate}
                  />
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default Index;
